const firebaseConfig = {
  apiKey: "AIzaSyCIn_VA0zZjEnhuRySueXUimHUeBQpm7Bo",
  authDomain: "nova-blog-3d833.firebaseapp.com",
  databaseURL: "https://nova-blog-3d833.firebaseio.com",
  projectId: "nova-blog-3d833",
  storageBucket: "nova-blog-3d833.firebasestorage.app",
  messagingSenderId: "901047629781",
  appId: "1:901047629781:web:1fdfee40a824597873af5c"
};

export default firebaseConfig;